/* eslint-disable no-unused-vars */
import { useEffect, useRef, useContext, useState } from 'react';
import Welcome from '../components/Welcome';
import ImportantDates from '../components/ImportantDates';
import NoticeToVacateForm from '../components/NoticeToVacateForm';
import { UIContext } from '../context/UIContext';
import Header from '../components/Header';
import Loading from '../components/Loading';
import { useNavigate } from 'react-router-dom';

const FormContainer = () => {
  const dateParentRef = useRef();

  const { getFormData, loading, formData, hasMultipleLeases, hasSelectedLease } =
    useContext(UIContext);
  const { community, lease, resident, unit } = formData;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getFormData();
    document.body.style.backgroundColor = '#F6F6F7';
  }, []);

  useEffect(() => {
    document.body.setAttribute('data-theme', community?.brand);
  }, [community?.brand]);

  useEffect(() => {
    const storedHasMultipleLeases = localStorage.getItem('hasMultipleLeases') === 'true';

    if (storedHasMultipleLeases && !hasSelectedLease) {
      navigate('../', { replace: true });
    } else {
      navigate('../form', { replace: true });
    }
  }, [hasSelectedLease]);

  useEffect(() => {
    if (!resident || !lease) return;

    if (window.pendo)
      window.pendo.initialize({
        visitor: {
          id: resident.email, // Required if user is logged in
          firstName: resident.firstName,
          lastName: resident.lastName
          // email:        // Optional
          // role:         // Optional

          // You can add any additional visitor level key-values here,
          // as long as it's not one of the above reserved names.
        },

        account: {
          id: lease.leaseId, // Highly recommended
          // name:         // Optional
          // planLevel:    // Optional
          // planPrice:    // Optional
          // creationDate: // Optional

          // You can add any additional account level key-values here,
          // as long as it's not one of the above reserved names.
          communityBrand: community?.brand,
          bedroom: unit.bedroom,
          communityCode: resident.communityCode,
          decideBy: lease.decideBy,
          leaseExpirationDate: lease.leaseExpirationDate,
          leaseTerm: lease.leaseTerm,
          communityName: community.name,
          communityState: lease.leaseId?.slice(0, 2)
        }
      });
  }, [lease, resident]);

  return (
    <div data-theme={community?.brand}>
      <div className="overflow">
        {loading ? (
          <Loading />
        ) : (
          <>
            <Header />
            <Welcome />
            <div className="max-w-screen-xl m-auto mt-5 bg-page">
              <div className="p-5 lg:px-0 md:px-10 lg:py-[25px] flex flex-col lg:flex-row  font-proxima box-border ">
                <div className="lg:p-0  gap-0  flex flex-col lg:justify-between lg:flex-row-reverse md:flex-row-reverse ">
                  <div
                    className="block  h-[357px]  lg:p-0 md:p-0 float-right  bg-[#FFF7E6] flex-1 shadow-lg md:z-10"
                    ref={dateParentRef}>
                    <ImportantDates dateParentRef={dateParentRef} setOpen={setOpen} open={open} />
                  </div>
                  <div className="lg:w-[75%] md:w-[55%]  lg:pr-12 md:pr-12 pt-5 lg:pt-0 md:pt-0">
                    <NoticeToVacateForm isOpen={open} />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default FormContainer;
